import { render, staticRenderFns } from "./ModuleEditorHeader.vue?vue&type=template&id=9b422da0"
import script from "./ModuleEditorHeader.vue?vue&type=script&lang=js"
export * from "./ModuleEditorHeader.vue?vue&type=script&lang=js"
import style0 from "./ModuleEditorHeader.vue?vue&type=style&index=0&id=9b422da0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports